import { Switch, Button, Dropdown } from "antd";
import { RightOutlined } from "@ant-design/icons";

const formatDate = (val) => {
  if (!val) return "—";
  return new Date(val).toLocaleDateString("en-GB");
};

export const getRecipeColumns = (
  onToggleDisable,
  onToggleTrending,
  onEdit,
  onDelete
) => [
    {
      title: "Recipe Name",
      dataIndex: "title",
      key: "title",
      render: (val) => val || "—",
    },
    {
      title: "Date Added",
      dataIndex: "createdAt",
      key: "createdAt",
      render: formatDate,
    },
    {
      title: "Date Edited",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: formatDate,
    },
    {
      title: "Disable Recipe",
      dataIndex: "isDisabled",
      key: "isDisabled",
      render: (_, record) => (
        <Switch
          checked={!!record.isDisabled}
          onChange={(val) => onToggleDisable(record._id, val)}
          style={{
            backgroundColor: record.isDisabled ? "#16a34a" : undefined,
          }}
        />
      ),
    },
    {
      title: "Trending Recipe",
      dataIndex: "isTrending",
      key: "isTrending",
      render: (_, record) => (
        <Switch
          checked={!!record.isTrending}
          onChange={(val) => onToggleTrending(record._id, val)}
          style={{
            backgroundColor: record.isTrending ? "#16a34a" : undefined,
          }}
        />
      ),
    },
    {
      title: "Saved By",
      key: "savedBy",
      render: () => "Admin",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            label: "Edit Recipe",
            onClick: () => onEdit?.(record),
          },
          {
            key: "trending",
            label: "Set as Trending Recipe",
            onClick: () => onToggleTrending?.(record._id, !record.isTrending),
          },
          {
            key: "disable",
            label: "Disable Recipe",
            onClick: () => onToggleDisable?.(record._id, !record.isDisabled),
          },
          {
            key: "delete",
            label: <span style={{ color: "#ef4444" }}>Delete Recipe</span>,
            onClick: () => onDelete?.(record),
          },
        ];

        return (
          <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
            <Button className="recipe-action-btn">
              Actions <RightOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
  ];